import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LISTS } from "../config";
import HeaderText from "../helpers/HeaderText";
import { useInView } from "react-intersection-observer";
import { SimpleGrid, Spinner, Center, Text } from "@chakra-ui/react";
import Product from "../product/Product";
import { useDispatch, useSelector } from "react-redux";
import { getProductsNew } from "../../slices/shop";

export default function NewArrivals() {
  const [activeTab, setActiveTab] = React.useState(
    LISTS.LAYDYWEAR_CATEGORIES[0].Name
  );
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { productListNew, status } = useSelector((state) => state.shop);
  useEffect(() => {
    dispatch(
      getProductsNew({
        filters: { categories: activeTab, sort : 'created_at', sort_order : 'desc',page_size:10 },
      })
    );
  }, [activeTab, dispatch]);

  const products = Array.isArray(productListNew.items) ? productListNew.items : [];

  return (
    <div ref={ref} className={`row fade-left m-0 ${inView ? "visible" : ""}`}>
      <HeaderText text="What's new" />

      <div className="col-lg-12 col-md-12 col-sm-12 pt-0 pb-4 mx-auto">
        <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
          {LISTS.LAYDYWEAR_CATEGORIES.map((item, index) => (
            <button
              type="button"
              key={index}
              className={`rounded-pill btn-badge-logo-1 ${
                activeTab === item.Name ? "active" : ""
              }`}
              onClick={() => setActiveTab(item.Name)}
            >
              {item.Name}
            </button>
          ))}
        </div>
      </div>

      <div className="col-lg-12 col-md-12 col-sm-12 pt-0 pb-3 px-2">
        {status === "loading" ? (
          <Center py={10}>
            <Spinner size="xl" />
          </Center>
        ) : products.length === 0 ? (
          <Center py={10}>
            <Text fontSize="lg" color="gray.500">
              No products found.
            </Text>
          </Center>
        ) : (
          <SimpleGrid
            columns={{ base: 2, sm: 2, md: 3, lg: 5, xl: 6, "2xl": 7 }}
            paddingX={4}
            gap="20px"
          >
            {products.map((product) => (
              <div
                key={product.id}
                onClick={() =>
                  navigate(`/product/${product.slug || product.id}`)
                }
                style={{ cursor: "pointer" }}
              >
                <Product product={product} />
              </div>
            ))}
          </SimpleGrid>
        )}
      </div>

      <div className="col-lg-12 col-md-12 col-sm-12 text-end pb-5 px-3">
        <button
          className="button-anm-1 learn-more"
          onClick={() => navigate(`/shop?category=${activeTab}`)}
        >
          <span className="circle" aria-hidden="true">
            <span className="icon arrow"></span>
          </span>
          <span className="button-text">View All</span>
        </button>
      </div>
    </div>
  );
}
